import InputProcessor from '../../../types/input-processor';
import Module from '../../../types/module';
import { AlmeUIInput } from '../../../types/input';
import { Dictionary } from '../../../types/rendering';

export default class PageAwarenessRequestProcessor extends Module implements InputProcessor {
    constructor(settings) {
        super(settings);
    }

    process(input: AlmeUIInput): AlmeUIInput {
        let inputParameters = input?.parameters ?? {};

        if (!inputParameters.Context) {
            inputParameters.Context = {};
        }

        const type = this.getType();
        const loc = this.getLocationObject();
        const docTitle = this.getDocumentTitle();

        (inputParameters.Context as Dictionary).CurrentUrl =
            this.generatePageAwarenessProperties(loc, type, docTitle);

        return Object.assign({}, input, { parameters: inputParameters });
    }

    getLocationObject() {
        return window.location;
    }

    getType() {
        return this._settings.PageAwareness.type;
    }

    getDocumentTitle() {
        return document.title;
    }

    generatePageAwarenessProperties(loc, type, docTitle) {
        return {
            AbsolutePath: loc.href,
            Protocol: loc.protocol,
            Host: loc.host,
            HostName: loc.hostname,
            Port: loc.port,
            //IE does not add the leading "/" and can cause problems with fpml
            Uri: loc.pathname.startsWith("/") ? loc.pathname : "/" + loc.pathname,
            Query: loc.search,
            Fragment: loc.hash,
            Origin: loc.origin,
            Type: type,
            PageName: docTitle
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/pageawareness/src/request-processor-pageawareness.ts